/**
 * Badge que reflete, de forma agregada, o estado de sincronização de um plano/produto
 * com o Stripe. Calculado no componente consumidor via `resolveStripeSyncState`.
 */

export type StripeSyncState = 'NOT_SYNCED' | 'NO_PRICE' | 'PENDING' | 'SYNCED';

interface Props {
  state: StripeSyncState;
}

const LABELS: Record<StripeSyncState, { text: string; className: string; title: string }> = {
  NOT_SYNCED: {
    text: 'Não sincronizado',
    className: 'bg-gray-100 text-gray-700',
    title: 'Este item ainda não existe no Stripe.',
  },
  NO_PRICE: {
    text: 'Sem preço',
    className: 'bg-red-100 text-red-800',
    title: 'Cadastre ao menos um preço por moeda antes de sincronizar.',
  },
  PENDING: {
    text: 'Pendente',
    className: 'bg-amber-100 text-amber-800',
    title: 'Sincronização enfileirada — o worker processa a cada 5 segundos.',
  },
  SYNCED: {
    text: 'Sincronizado',
    className: 'bg-green-100 text-green-800',
    title: 'Todos os preços estão materializados como Stripe Prices.',
  },
};

export function StripeSyncBadge({ state }: Props) {
  const { text, className, title } = LABELS[state];
  return (
    <span
      title={title}
      className={`inline-flex px-2 py-1 text-[10px] font-semibold uppercase tracking-wide rounded-full ${className}`}
    >
      {text}
    </span>
  );
}
